import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';
import { capitalizeEachWord } from '../validators';

const validateText = (value: string, minLength: number = 1): boolean => {
  return value.trim().length >= minLength;
};

export const Step21_Mae: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.mothersName) {
      newErrors.mothersName = 'Nome da mãe é obrigatório';
    } else if (!validateText(data.mothersName, 3)) {
      newErrors.mothersName = 'Preencha o nome completo';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (data.fullName.trim().split(' ').length < 2) {
      setErrors({ fullName: 'Por favor, insira seu nome completo' });
      return;
    }
    data.fullName = data.fullName.trim().replace(/\s+/g, ' ');
    data.fullName = capitalizeEachWord(data.fullName);

    onNext({ mothersName: data.mothersName }, 'step11_estadocivil');
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Qual é o nome da sua mãe?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Precisamos do nome completo da sua mãe para validação de identidade. Será mantido em sigilo.
        </p>
      </div>
      <FormFieldGroup
        label="Nome completo da Mãe"
        error={errors.mothersName}
        required
      >
        <input
          type="text"
          placeholder="Maria Silva"
          value={data.mothersName || ''}
          onChange={(e) => handleFieldChange('mothersName', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step21_Mae;
